import {
  createFilterDTOSchema,
  createPageQueryDTOSchema,
  DEFAULT_PAGE_LIMIT,
  timestampDTOSchema,
} from '@tempo-io/common-dto';
import { sanitizeFreeText } from '@tempo-io/string-util';
import { z } from 'zod';
import { roleSchema } from './user-dto';

export const internalMembershipDTOSchema = z.object({
  id: z.number(),
  userId: z.string().nonempty(),
  organizationId: z.string().nonempty(),
  role: roleSchema,
  ...timestampDTOSchema.shape,
});

export const membershipDTOSchema = z.object({
  organizationId: z.string().nonempty(),
  title: z
    .string()
    .nullish()
    .transform((v) => v ?? undefined)
    .pipe(z.string().optional()),
});

export const membershipArrayDTOSchema = z.array(membershipDTOSchema);

export const membershipUpdateDTOSchema = z.object({
  title: z
    .string()
    .transform((v) => sanitizeFreeText(v))
    .pipe(
      z
        .string()
        .min(1, { message: 'Title cannot be empty or just spaces' })
        .max(80, { message: 'Title is too long' }),
    ),
});

const internalMembershipSearchSortableFields = ['id', 'createdAt', 'updatedAt'] as const;

export const { filterSchema: internalMembershipSearchFilterSchema } = createFilterDTOSchema({
  userId: 'string',
  organizationId: 'string',
  createdAt: 'date',
  updatedAt: 'date',
});

export const internalMembershipSearchInputDTOSchema = z
  .object({
    filter: internalMembershipSearchFilterSchema,
    ...createPageQueryDTOSchema({
      sortableFields: internalMembershipSearchSortableFields,
      defaultSortBy: 'createdAt',
    }).shape,
  })
  .optional()
  .default({ sortOrder: 'asc', sortBy: 'createdAt', limit: DEFAULT_PAGE_LIMIT });
